export function buildParameters(templateParameter, { id, type }) {
    return {
        ...templateParameter,

        label: `${templateParameter.label}`,
        parameters: templateParameter.parameters.map((param) => ({
            ...param,
            parameterKey: `${id}|${param.parameterKey}`,
            instanceId: id,
            instanceType: type,
        })),
    };
}

export function configBuilder(
    configuration,
    notificationInstances,
    instanceTypeTemplates
) {
    const sections = notificationInstances.map((instance) => ({
        id: instance.id,
        label: instance.name,
        subSections: instanceTypeTemplates[instance.type].map((y) =>
            buildParameters(y, instance)
        ),
    }));

    return { ...configuration, sections };
}
